import type { Board } from "./types";
import { boardDims } from "./board";
import { findDirectMatchPair } from "./matching";
import { getGroup, getMaxSteps, applySlideMove, findGrabbedMatch } from "./slide";

const DIRS: ReadonlyArray<[number, number]> = [
  [1, 0],
  [-1, 0],
  [0, 1],
  [0, -1],
];

/** 是否存在无需滑动就能直接消除的一对。 */
export function existsDirectMatch(board: Board): boolean {
  return findDirectMatchPair(board) !== null;
}

// 是否还有任何有效走法（活棋判定）。
// 有效走法 = 直接消除对，或存在某次滑动使「被抓住的格子」滑过去后能配对。
// 死局判定必须与实际滑动规则严格对齐，否则会误判。
export function hasAnyValidMove(board: Board): boolean {
  if (existsDirectMatch(board)) return true;

  const { w, h } = boardDims(board);
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      if (board[y][x] === null) continue;
      for (const [dx, dy] of DIRS) {
        const group = getGroup(x, y, dx, dy, board);
        if (!group.length) continue;
        const maxSteps = getMaxSteps(group, dx, dy, board);
        for (let s = 1; s <= maxSteps; s++) {
          const moved = applySlideMove(board, group, dx * s, dy * s);
          if (findGrabbedMatch(moved, x + dx * s, y + dy * s) !== null) {
            return true;
          }
        }
      }
    }
  }
  return false;
}
